import { render, staticRenderFns } from "./sponsor-card.vue?vue&type=template&id=019716cb&scoped=true&"
import script from "./sponsor-card.vue?vue&type=script&lang=ts&"
export * from "./sponsor-card.vue?vue&type=script&lang=ts&"
import style0 from "./sponsor-card.vue?vue&type=style&index=0&id=019716cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019716cb",
  null
  
)

export default component.exports